var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 19C1.2037 19 0.810185 18.8414 0.486111 18.5243C0.162037 18.2072 0 17.8221 0 17.3691V15.3033L4.44444 11.4435V19H1.66667ZM5.55556 19V14.6509H14.4444V19H5.55556ZM15.5556 19V10.0844L10.8056 5.95279L14.1667 3.04435L19.4444 7.63805C19.6296 7.80114 19.7685 7.98689 19.8611 8.19528C19.9537 8.40367 20 8.62566 20 8.86123V17.3691C20 17.8221 19.838 18.2072 19.5139 18.5243C19.1898 18.8414 18.7963 19 18.3333 19H15.5556ZM0 13.8355V8.86123C0 8.62566 0.0462963 8.39914 0.138889 8.18169C0.231481 7.96423 0.37037 7.78302 0.555556 7.63805L8.88889 0.407725C9.03704 0.262756 9.20833 0.15856 9.40278 0.0951359C9.59722 0.031712 9.7963 0 10 0C10.2037 0 10.4028 0.031712 10.5972 0.0951359C10.7917 0.15856 10.963 0.262756 11.1111 0.407725L13.3333 2.33763L0 13.8355Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f9ca628cba46025e34dc2d46c41c9001.svg";
export { ForwardRef as ReactComponent };